import { Schema } from "effect";
import * as z from "zod/v4";
import { ConversationId } from "../../../ids/definitions";
import { zodToEffectSchema } from "../../zod";
import { CONVERSATION_STATUSES } from "./conversation";

export const BulkConversationActionZod = z.discriminatedUnion("_tag", [
  z.object({
    _tag: z.literal("setConversationStatus"),
    status: z.enum(CONVERSATION_STATUSES),
  }),
  z.object({
    _tag: z.literal("setReadStatus"),
    status: z.enum(["read", "unread"]),
  }),
  z.object({ _tag: z.literal("setAssignee"), userId: z.string() }),
  z.object({ _tag: z.literal("addTags"), tagIds: z.array(z.string()) }),
  z.object({ _tag: z.literal("removeTags"), tagIds: z.array(z.string()) }),
]);

export const BulkConversationAction = zodToEffectSchema(
  BulkConversationActionZod,
);
export type BulkConversationAction = typeof BulkConversationAction.Type;

export const StartBulkConversationActionInput = Schema.Struct({
  conversationIds: Schema.Array(ConversationId),
  action: BulkConversationAction,
});
export type StartBulkConversationActionInput =
  typeof StartBulkConversationActionInput.Type;

export const StartBulkConversationActionResponse = Schema.Struct({
  workflowId: Schema.String,
});
export type StartBulkConversationActionResponse =
  typeof StartBulkConversationActionResponse.Type;
